// signUp user
export const REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export  const REGISTER_USER_FAIL = "REGITSER_USER_FAIL";

// Login
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

// to fetch exiting user data.
export const AUTHENTICATED_USER_REQUEST = 'AUTHENTICATED_USER_REQUEST';
export const AUTHENTICATED_USER_REQUEST_SUCCESS = 'AUTHENTICATED_USER_REQUEST_SUCCESS';
export const AUTHENTICATED_USER_REQUEST_FAIL = 'AUTHENTICATED_USER_REQUEST_FAIL';

// to know number of user that we have.
export const TOTAL_NUMBER_USER_REQUEST_SUCCESS = "TOTAL_NUMBER_USER_REQUEST_SUCCESS"
